var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column justify-center align-center h-100" },
    [
      _c(
        "div",
        {
          staticClass: "my-auto",
          style: { maxWidth: _vm.isMobile ? "" : "452px" },
        },
        [
          _vm._t("main"),
          _vm._v(" "),
          !_vm.isMobile && _vm.$scopedSlots.actions
            ? _c(
                "div",
                {
                  staticClass: "text-center",
                  class: { "mt-6": _vm.$slots.main },
                },
                [
                  _vm._t("actions", null, {
                    buttonProps: {
                      elevation: 0,
                      color: "primary",
                      width: 240,
                    },
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isMobile && _vm.$scopedSlots.actions
        ? _c(
            "div",
            { staticClass: "w-100" },
            [
              _vm._t("actions", null, {
                buttonProps: {
                  elevation: 0,
                  color: "primary",
                  block: true,
                },
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }